export const messages = {
  en: {
    productGroupManage: {
      queryCondition: 'Query Conditions',
      selectProductName: 'Please select product name',
      selectStatus: 'Please select status',
      selectRebate: 'Please select rebate status',
      query: 'Query',
      groupProducts: 'Group Products',
      add: 'Add',
      id: 'ID',
      productImage: 'Product Image',
      productName: 'Product Name',
      groupPeople: 'Group People',
      groupPrice: 'Group Price',
      singlePrice: 'Single Price',
      status: 'Status',
      validityPeriod: 'Validity Period',
      isRebate: 'Is Rebate',
      leaderRebate: 'Leader Rebate',
      operation: 'Operation',
      edit: 'Edit',
      delete: 'Delete',
      enable: 'Enable',
      disable: 'Disable',
      yes: 'Yes',
      no: 'No',
      confirmOperation: 'Please confirm your operation!',
      confirmDeleteProduct: 'Confirm to delete group product',
      cancel: 'Cancel',
      confirmDelete: 'Confirm Delete!',
      addProduct: 'Add Product',
      selectProduct: 'Select Product',
      searchProdName: 'Search product name',
      selectCategory: 'Please select category',
      selectSpec: 'Please select specification',
      productDesc: 'Product Description',
      productDescRequired: 'Required, please enter product description',
      groupPeopleRequired: 'Required, please enter group people count',
      groupPriceRequired: 'Required, please enter group price',
      statusRequired: 'Required, please select status',
      startTime: 'Start Time',
      startTimeRequired: 'Required, please enter start time',
      endTime: 'End Time',
      endTimeRequired: 'Required, please enter end time',
      isRebateRequired: 'Required, please select rebate status',
      commercialPrice: 'Commercial price',
      rebateNumber: 'Number',
      rebate: 'Rebate',
      save: 'Save'
    }
  },
  zh: {
    productGroupManage: {
      queryCondition: '查询条件',
      selectProductName: '请选择产品名称',
      selectStatus: '请选择状态',
      selectRebate: '请选择是否返佣',
      query: '查询',
      groupProducts: '拼团商品',
      add: '添加',
      id: '编号',
      productImage: '商品图片',
      productName: '商品名称',
      groupPeople: '拼团人数',
      groupPrice: '拼团金额',
      singlePrice: '单买金额',
      status: '状态',
      validityPeriod: '有效期',
      isRebate: '是否返佣',
      leaderRebate: '团长返佣',
      operation: '操作',
      edit: '修改',
      delete: '删除',
      enable: '启用',
      disable: '停用',
      yes: '是',
      no: '否',
      confirmOperation: '请确认您的操作!',
      confirmDeleteProduct: '确定删除拼团商品',
      cancel: '取消',
      confirmDelete: '确认删除!',
      addProduct: '添加商品',
      selectProduct: '选择商品',
      searchProdName: '搜索商品名称',
      selectCategory: '请选择分组',
      selectSpec: '请选择规格',
      productDesc: '商品简介',
      productDescRequired: '必填，请填写商品简介',
      groupPeopleRequired: '必填，请填写拼团人数',
      groupPriceRequired: '必填，请填写拼团金额',
      statusRequired: '必填，请选择状态',
      startTime: '开始时间',
      startTimeRequired: '必填，请填写开始时间',
      endTime: '结束时间',
      endTimeRequired: '必填，请填写结束时间',
      isRebateRequired: '必填，请选择是否返佣',
      commercialPrice: '商用价的',
      rebateNumber: '几',
      rebate: '返佣',
      save: '保存'
    }
  }
}